<template>
  <div class="popup-content-status">
    <card-status-small
      v-for="datum in dataForCards"
      v-bind:key="datum.id"
      v-bind="datum"
      class="content-item"
      v-on="$listeners"
    />
  </div>
</template>

<script>
import CardStatusSmall from '@/components/status/AppCardStatusSmall.vue'

export default {
  name: 'AppMapPopupContentStatus',
  components: {
    'card-status-small': CardStatusSmall,
  },
  props: {
    /**
     * ステイタスデータ
     */
    data: {
      type: Array,
      default: () => [],
    },
    /**
     * ソートキー
     */
    sortKey: {
      type: String,
      default: null,
    },
    /**
     * ソート方向
     * @values 'asc', 'desc'
     */
    sortDirection: {
      type: String,
      default: 'asc',
    },
  },
  computed: {
    /**
     * カード用データ
     * @type {Array.<Object>}
     */
    dataForCards: function () {
      if (!this.data) return []

      let data = [...this.data]

      if (this.sortKey) {
        data.sort(this.sortFunction)
      }

      return data.map((datum) => {
        return {
          id: datum.id,
          userId: datum.user_id,
          userName: datum.user_name,
          statusName: datum.status_name,
          updateAt: datum.status_update_at,
        }
      })
    },
    /**
     * ソート関数
     * @type {Function}
     */
    sortFunction: function () {
      if (this.sortDirection === 'asc') {
        return (a, b) => {
          const valueA = a[this.sortKey]
          const valueB = b[this.sortKey]
          if (valueA === valueB) return 0
          return valueA > valueB ? 1 : -1
        }
      } else if (this.sortDirection === 'desc') {
        return (a, b) => {
          const valueA = a[this.sortKey]
          const valueB = b[this.sortKey]
          if (valueA === valueB) return 0
          return valueA > valueB ? -1 : 1
        }
      } else {
        return () => 0
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.popup-content-status {
  max-width: 16rem;
  max-height: calc(5.5rem * 5.5);
  overflow-x: hidden;
  overflow-y: auto;
  @include mixin-scrollbar;
}

.content-item {
  &:first-child {
    padding-top: 4px;
    height: calc(5rem + 4px);
  }

  &:last-child {
    padding-bottom: 4px;
    height: calc(5rem + 4px);
    border-bottom: 1px solid transparent;
  }

  &:not(:last-child) {
    border-bottom: 1px solid #e3e3e3;
  }
}
</style>
